import React, { useState } from 'react';

import { Alert, AlertTitle, Autocomplete, Backdrop, Box, Button, CircularProgress, Grid, InputLabel, IconButton, Select, MenuItem, TextField, FormControl, Snackbar, FormHelperText } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { countries, USA_STATES, CANADA_PROVINCES, asthaans, SARAVAN, AirlineNames, INDIA_AIRPORT_LIST, LOCAL_DATE_FORMAT, OVERIDE_USER_LIST } from '../../constants';
import AutoCompleteWithOther from '../general/autoCompleteWithOther';
import ConfirmationModal from "../general/confirmation";
import { valid } from 'semver';

const AddEditUserForm = (props) => {
  const {sangat, handleCloseCallback, currentUser, onSaveCallBack, onSaveAndAddNewCallBack, title, fullScreen, saveBtnText, hideCloseBtn } = props;

  const isRoomAdmin = localStorage.getItem("userRole") ? localStorage.getItem("userRole").includes("ROLE_ROOMS_WRITE") : false;
  
  const [overrideValidation, setOverrideValidation] = useState(currentUser && OVERIDE_USER_LIST.includes(currentUser) ? true : false);
  const [showFlightInfomation, setShowFlightInformation] = useState(sangat && sangat.user_ride_from_airport === "YES" ? true : false);
  const [showValidationMessages, setShowValidationMessages] = useState(false);
  const [loading, setLoading] = useState(false);
  const [stateOptions, setStateOptions] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [snack, setSnack] = useState({ message: "", duration: 0, open: false, severity: "success" });
  //Personal information

  const [firstName, setFirstName] = useState(sangat ? sangat.user_firstName : "");
  const [middleName, setMiddleName] = useState(sangat ? sangat.user_middleName : "")
  const [lastName, setLastName] = useState(sangat ? sangat.user_lastName : "")
  // TODO: BACKEND NAME MISMATCH
  const [dob, setDob] = useState(sangat && sangat.user_yearOfBirth ? dayjs(sangat.user_yearOfBirth, LOCAL_DATE_FORMAT) : null);
  const [gender, setGender] = useState(sangat ? sangat.user_gender : '');
  const [city, setCity] = useState(sangat ? sangat.user_city : "");
  const [state, setState] = useState(sangat ? sangat.user_state : "");
  const [country, setCountry] = useState(sangat ? sangat.user_country : "");
  // TODO: BACKEND IS USING WRONG NAMING
  const [closestAsthan, setClosestAsthan] = useState(sangat ? sangat.user_goingToAsthan : "");

  const [phone, setPhone] = useState(sangat ? sangat.user_phoneNumber : "");
  // TODO: fix backend naming, should be secondaryPhone and not emergency contact
  const [secondaryPhone, setSecondaryPhone] = useState(sangat ? sangat.user_emergencyContact : "");
  const [email, setEmail] = useState(sangat ? sangat.user_email : "");
  //TODO: WHAT IS ALLERGY AND HAS ALLERGY - REMOVE THESE FEILDS FROM BACKEND

  //Arriving Flight
  const [arrivingFlightNumber, setArrivingFlightNumber] = useState(sangat ? sangat.user_arrivingFlightNumber : "");
  const [arrivingFlightAirline, setArrivingFlightAirline] = useState(sangat ? sangat.user_arrivingFlightName : "");
  const [arrivingFlightAirport, setArrivingFlightAirport] = useState(sangat ? sangat.user_arrivingFlightAirport : "");
  const [arrivingFlightDate, setArrivingFlightDate] = useState(sangat && sangat.user_arrivingFlightDate ? dayjs(sangat.user_arrivingFlightDate, LOCAL_DATE_FORMAT) : null);
  const [arrivingFlightTime, setArrivingFlightTime] = useState(sangat && sangat.user_arrivingFlightTime ? dayjs(sangat.user_arrivingFlightTime, "HH:mm") : null);
  
  // Departing Flight
  const [departingFlightNumber, setDepartingFlightNumber] = useState(sangat ? sangat.user_departingFlightNumber : "");
  const [departingFlightAirline, setDepartingFlightAirline] = useState(sangat ? sangat.user_departingFlightName : "");
  const [departingFlightAirport, setDepartingFlightAirport] = useState(sangat ? sangat.user_departingFlightAirport : "");
  const [departingFlightDate, setDepartingFlightDate] = useState(sangat && sangat.user_departingFlightDate ? dayjs(sangat.user_departingFlightDate, LOCAL_DATE_FORMAT) : null);
  const [departingFlightTime, setDepartingFlightTime] = useState(sangat && sangat.user_departingFlightTime ? dayjs(sangat.user_departingFlightTime, "HH:mm") : null);
  const [comments, setComments] = useState(sangat ? sangat.user_comments : "");
  const [needRide, setIsNeedRide] = useState(sangat ? sangat.user_ride_from_airport : "");
  
  //Accomodation
  const [saravan, setSaravan] = useState(sangat? sangat.user_saravan : null);
  const [room, setRoom] = useState(sangat ? sangat.user_room : "");


  React.useEffect(() => {
    setFirstName(sangat ? sangat.user_firstName : "");
    setMiddleName(sangat ? sangat.user_middleName : "");
    setLastName(sangat ? sangat.user_lastName : "")
    setDob(sangat && sangat.user_yearOfBirth ? dayjs(sangat.user_yearOfBirth, LOCAL_DATE_FORMAT) : null);
    setGender(sangat ? sangat.user_gender : '');
    setCity(sangat ? sangat.user_city : "");
    setState(sangat ? sangat.user_state : "");
    setCountry(sangat ? sangat.user_country : "");
    // TODO: BACKEND IS USING WRONG NAMING
    setClosestAsthan(sangat ? sangat.user_goingToAsthan : "");
    //TODO: WHAT IS ALLERGY AND HAS ALLERGY
    setPhone(sangat ? sangat.user_phoneNumber : "");
    // TODO: fix backend naming, should be secondaryPhone and not emergency contact
    setSecondaryPhone(sangat ? sangat.user_emergencyContact : "");
    setEmail(sangat ? sangat.user_email : "");

    //Arriving Flight
    setArrivingFlightNumber(sangat ? sangat.user_arrivingFlightNumber : "");
    setArrivingFlightAirline(sangat ? sangat.user_arrivingFlightName : "");
    setArrivingFlightAirport(sangat ? sangat.user_arrivingFlightAirport : "");
    setArrivingFlightDate(sangat && sangat.user_arrivingFlightDate ? dayjs(sangat.user_arrivingFlightDate, LOCAL_DATE_FORMAT) : null);
    setArrivingFlightTime(sangat && sangat.user_arrivingFlightTime ? dayjs(sangat.user_arrivingFlightTime, "HH:mm") : null);

    // Departing Flight
    setDepartingFlightNumber(sangat ? sangat.user_departingFlightNumber : "");
    setDepartingFlightAirline(sangat ? sangat.user_departingFlightName : "");
    setDepartingFlightAirport(sangat ? sangat.user_departingFlightAirport : "");
    setDepartingFlightDate(sangat && sangat.user_departingFlightDate ? dayjs(sangat.user_departingFlightDate, LOCAL_DATE_FORMAT) : null);
    setDepartingFlightTime(sangat && sangat.user_departingFlightTime ? dayjs(sangat.user_departingFlightTime, "HH:mm") : null);
    setComments(sangat ? sangat.user_comments : "");
    setIsNeedRide(sangat ? sangat.user_ride_from_airport : "");

    //Accomodation
    // setSaravan(sangat?.user_saravan ? SARAVAN.find((obj) => obj.name === sangat?.user_saravan) : "");
    setSaravan(sangat? sangat.user_saravan : null);
    setRoom(sangat ? sangat.user_room : "");
    


  }, [sangat]);

  const closeSnack = () => {
    setSnack({ ...snack, open: false });
  }

  const handleClose = () => {
    handleCloseCallback();
  }

  const isValidRequiredField = (fieldValue) => {
    if (showValidationMessages && !fieldValue) {
      return false;
    }
    return true;
  }
  const getRequiredFieldHelperText = (fieldValue, fieldName) => {
    if (isValidRequiredField(fieldValue)) {
      return "";
    }
    return fieldName + " is a required field."
  }
  const isValidEmail = (email, isRequired) => {
    if (!showValidationMessages) {
      return true;
    }
    if (isRequired && !isValidRequiredField(email)) {
      return false;
    } else if (email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    }
    return true;
  };

  const getEmailHelperText = (email, isRequired, fieldName) => {
    if (!showValidationMessages) {
      return "";
    }
    if (isValidEmail(email, isRequired)) {
      return "";
    } else {
      return fieldName + " must be a valid email.";
    }
  }

  const isValidPhoneNumber = (phoneNumber, isRequired) => {
    if (!showValidationMessages) {
      return true;
    }
    if (isRequired && !isValidRequiredField(phoneNumber)) {
      return false;
    } else if (phoneNumber) {
      if (isNaN(phoneNumber)) {
        return false;
      }
      if (phoneNumber <= 0) {
        return false;
      }
      if (phoneNumber.toString().length < 10) {
        return false;
      }
    }
    return true;
  }

  const getPhoneHelperText = (phoneNumber, isRequired, fieldName) => {
    if (isValidPhoneNumber(phoneNumber, isRequired)) {
      return "";
    } else {
      return fieldName + " must be a valid number atleast 10 digits long";
    }
  }

  const getDateFieldLabel = (fieldName) => {
    return fieldName + " (" + LOCAL_DATE_FORMAT + ")";
  }
  const getDateHelperText = (dateValue, isRequired, fieldName) => {

    if (isValidDate(dateValue, isRequired)) {
      return "";
    }
    return fieldName + " must be a valid date";
  }

  const getDobHelperText = (dateValue, isRequired, fieldName) => {
    if (!showValidationMessages) {
      return true;
    }
    if (!isValidDate(dateValue, isRequired)) {
       return fieldName + " must be a valid date";
    } else if  (dateValue &&  !dateValue.isBefore(new Date())) {
      return fieldName + " must be in the past"
    } else {
      return ""
    }
  }

  const getArrivalDateHelperText = () => {
    if (!showValidationMessages) {
      return true;
    }
    if(!isValidDate(arrivingFlightDate, true)) {
      return  "Arrival date must be a valid date";
    }  
     //super user can enter past dates
     if (!overrideValidation) {
      if (!sangat || !sangat.user_arrivingFlightDate) {
        if (arrivingFlightDate.isBefore(new Date())) {
          return "Arriving date must be in the future";
        }
      } else if(arrivingFlightDate.isBefore(dayjs(sangat.user_arrivingFlightDate, LOCAL_DATE_FORMAT)) && arrivingFlightDate.isBefore(new Date())) {
          return "Arriving date must be in the future";
      } 
    }
    if(!isValidDate(departingFlightDate, true)) {
      return  "";
    } 

  
    if(arrivingFlightDate && departingFlightDate && !arrivingFlightDate.isBefore(departingFlightDate)){
      return "Arriving date must be before departing date"
    }
  }

  const getDepartureDateHelperText = () => {
    if (!showValidationMessages) {
      return true;
    }
    if(!isValidDate(departingFlightDate, true)) {
      return  "Departing date must be a valid date";
    }  
    if(!isValidDate(arrivingFlightDate, true)) {
      return  "";
    } 

    if(arrivingFlightDate && departingFlightDate && !arrivingFlightDate.isBefore(departingFlightDate)){
      return "Departure date must be after arrival date"
    }
  }

  const getTimeHelperText = (dateValue, isRequired, fieldName) => {
    if (!showValidationMessages) {
      return true;
    }
    if (isValidDate(dateValue, isRequired)) {
      return "";
    }
    return fieldName + " must be a valid time";
  }

  const isValidTime = (timeValue, isRequired) => {
    if (!showValidationMessages) {
      return true;
    }
    if (isRequired && !timeValue) {
      return false;
    } else if (timeValue && !dayjs(timeValue, 'HH:mm', true).isValid()) {
      return false;
    }
    return true;
  }

  const isValidDate = (dateValue, isRequired) => {
    if (!showValidationMessages) {
      return true;
    }
    if (isRequired && !dateValue) {
      return false;
    }
    if (dateValue && !dayjs(dateValue, LOCAL_DATE_FORMAT, true).isValid()) {
      return false;
    }
    return true;
  }

  const isValidDob = (dateValue, isRequired) => {
    if (!showValidationMessages) {
      return true;
    }
    if (isRequired && !dateValue) {
      return false;
    }
    if (dateValue && (!dayjs(dateValue, LOCAL_DATE_FORMAT, true).isValid() || !dateValue.isBefore(new Date()))) {
      return false;
    }
    return true;
  }

  const isValidArrivalDate = () => {
    if (!showValidationMessages) {
      return true;
    }
    if(!isValidDate(arrivingFlightDate, true)) {
      return false;
    }
    if (!overrideValidation) {
      if (!sangat || !sangat.user_arrivingFlightDate) {
        if (arrivingFlightDate.isBefore(new Date())) {
          return false;
        }
      } else if(arrivingFlightDate.isBefore(dayjs(sangat.user_arrivingFlightDate, LOCAL_DATE_FORMAT)) && arrivingFlightDate.isBefore(new Date())) {
          return false;
      } 
    }
    //check if departing date is valid so the comparison below will work.
    if(!isValidDate(departingFlightDate, true)) {
      return true;
    } 
    //super user can enter past dates
   

    else if(arrivingFlightDate && departingFlightDate && !arrivingFlightDate.isBefore(departingFlightDate)) {
      return false;
    }
    return true;

  } 

  const isValidDepartureDate = () => {
    if (!showValidationMessages) {
      return true;
    }
    if(!isValidDate(departingFlightDate, true)) {
      return false;
    }   
    //check if arriving date is valid so the comparison below will work.
    else if(!isValidDate(arrivingFlightDate, true)) {
      return true;
    } 
    else if(arrivingFlightDate && departingFlightDate && !arrivingFlightDate.isBefore(departingFlightDate)) {
      return false;
    }
    return true;

  } 

  const deleteUser = () => {
    setShowConfirmationModal(!showConfirmationModal);
  }




  const isValidForm = () => {
    setShowValidationMessages(true);
    // required fields

    let isValid = true;
    // Basic User Info

    if (!firstName || !lastName || !middleName || !gender ||
      !dob || !closestAsthan || !country || !state ||
      !city || !phone) {
      isValid = false;
    }

    // Flight Info
    if (showFlightInfomation) {
      if (!arrivingFlightAirline || !arrivingFlightNumber
        || !arrivingFlightDate || !arrivingFlightTime || !arrivingFlightAirport ||
        !needRide || !departingFlightAirline || !departingFlightNumber ||
        !departingFlightDate || !departingFlightTime || !departingFlightAirport
        || !isValidDate(arrivingFlightDate) || !isValidDate(departingFlightDate)
        || !isValidTime(arrivingFlightTime) || !isValidTime(departingFlightTime)
      ) {
        isValid = false;
      }
    } else if (!arrivingFlightDate || !departingFlightDate){
      isValid = false;
    }
    if(!needRide) {
      isValid = false;
    }
    // phones and emails
    if(phone && (isNaN(phone) || phone < 0 || phone.toString().length < 10)) {
      isValid = false;
    }
    if(secondaryPhone && (isNaN(secondaryPhone) || secondaryPhone < 0 || secondaryPhone.toString().length < 10)) {
      isValid = false;
    }
    if (email && !String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )) {
      isValid = false;
    }
    if (dob && (!dayjs(dob, LOCAL_DATE_FORMAT, true).isValid() || !dob.isBefore(new Date()))) {
      isValid = false;
    }
    if(arrivingFlightDate && departingFlightDate && !arrivingFlightDate.isBefore(departingFlightDate)) {
      isValid = false;
    }
      //super user can enter past dates
      if (!overrideValidation) {
        if (!sangat || !sangat.user_arrivingFlightDate) {
          if (arrivingFlightDate.isBefore(new Date())) {
            isValid = false;
          }
        } else if(arrivingFlightDate.isBefore(dayjs(sangat.user_arrivingFlightDate, LOCAL_DATE_FORMAT)) && arrivingFlightDate.isBefore(new Date())) {
            isValid = false;
        } 
      }
    

    if (!isValid) {
      setSnack({ open: true, severity: "error", durration: 6000, message: "Please enter all of the required fields and make sure the information is valid." })
    }
    return isValid;

  }
  
  const getArrivalUpdatedTime = () => 
{
  if (!sangat) {
    return new Date();
  }  
  else if (sangat.user_arrivingFlightDate != arrivingFlightDate?.format(LOCAL_DATE_FORMAT) || (sangat.user_arrivingFlightTime && sangat.user_arrivingFlightTime != arrivingFlightTime?.format("HH:mm")) || sangat.user_arrivingFlightAirport != arrivingFlightAirport ) {
    return new Date();
  }
  else return sangat.user_arrivalUpdatedAt;
}
  const buildFormValue = () => {
    if (needRide === "YES") {
    return {
      user_firstName: firstName,
      user_middleName: middleName,
      user_lastName: lastName,
      user_yearOfBirth: dob.format(LOCAL_DATE_FORMAT),
      user_gender: gender,
      user_city: city,
      user_state: state,
      user_country: country,
      user_phoneNumber: phone,
      user_email: email,
      user_arrivingFlightNumber: arrivingFlightNumber,
      user_arrivingFlightName: arrivingFlightAirline,
      user_arrivingFlightAirport: arrivingFlightAirport,
      user_arrivingFlightDate: arrivingFlightDate.format(LOCAL_DATE_FORMAT),
      user_arrivingFlightTime: arrivingFlightTime ? arrivingFlightTime.format("HH:mm") : "",
      user_departingFlightNumber: departingFlightNumber,
      user_departingFlightName: departingFlightAirline,
      user_departingFlightAirport: departingFlightAirport,
      user_departingFlightDate: departingFlightDate.format(LOCAL_DATE_FORMAT),
      user_departingFlightTime: departingFlightTime ? departingFlightTime.format("HH:mm") : "",
      user_goingToAsthan: closestAsthan,
      user_emergencyContact: secondaryPhone,
      user_comments: comments,
      user_ride_from_airport: needRide,
      user_last_updated_by: currentUser ? currentUser.toUpperCase() : "",
      user_arrivalUpdatedAt: getArrivalUpdatedTime(),
      user_saravan: saravan,
      user_room: room
    };
  } else {
    return {
      user_firstName: firstName,
      user_middleName: middleName,
      user_lastName: lastName,
      user_yearOfBirth: dob.format(LOCAL_DATE_FORMAT),
      user_gender: gender,
      user_city: city,
      user_state: state,
      user_country: country,
      user_phoneNumber: phone,
      user_email: email,
      user_arrivingFlightNumber: "",
      user_arrivingFlightName: "",
      user_arrivingFlightAirport: "",
      user_arrivingFlightDate: arrivingFlightDate.format(LOCAL_DATE_FORMAT),
      user_arrivingFlightTime: "",
      user_departingFlightNumber: "",
      user_departingFlightName: "",
      user_departingFlightAirport: "",
      user_departingFlightDate: departingFlightDate.format(LOCAL_DATE_FORMAT),
      user_departingFlightTime:  "",
      user_goingToAsthan: closestAsthan,
      user_emergencyContact: secondaryPhone,
      user_comments: comments,
      user_ride_from_airport: needRide,
      user_last_updated_by: currentUser ? currentUser.toUpperCase() : "",
      user_arrivalUpdatedAt: getArrivalUpdatedTime(),
      user_saravan: saravan,
      user_room: room 
    };
  }
  }

  const saveAndAddNewSangat = async () => {
    setShowValidationMessages(true);
    if (!isValidForm()) {
      return;
    }
    onSaveAndAddNewCallBack(buildFormValue());


  }

  const addNewSangat = async () => {
    setShowValidationMessages(true);
    if (!isValidForm()) {
      return;
    }
    onSaveCallBack(buildFormValue());
  }


  const setSangatFirstName = (e) => {
    e.preventDefault();
    setFirstName(e.target.value ? e.target.value.toUpperCase() : "");
  }

  const setSangatMiddleName = (e) => {
    setMiddleName(e.target.value ? e.target.value.toUpperCase() : "");
  }

  const setSangatLastName = (e) => {
    setLastName(e.target.value ? e.target.value.toUpperCase() : "");
  }

  const setSangatArrivalTime = (value) => {
    setArrivingFlightTime(value);
  }

  const setSangatDepartureTime = (value) => {
    setDepartingFlightTime(value);
  }



  const setSangatDob = (newDob) => {

    {/* TODO: front end and backend name mismatch backend is using user_yearOfBirth*/ }
    setDob(newDob)
  }

  const setSangatGender = (e) => {
    setGender(e.target.value ? e.target.value.toUpperCase() : "");
  }


  const setSangatCity = (e) => {
    setCity(e.target.value ? e.target.value.toUpperCase() : "");
  }

  const handleCountryChange = (newValue) => {
    setCountry(newValue);
    setState("");
    if (newValue && newValue.toUpperCase() === "CANADA") {
      setStateOptions(CANADA_PROVINCES);
    } else if (newValue && newValue.toUpperCase() === "USA") {
      setStateOptions(USA_STATES);
    } else {
      setStateOptions([]);
    }
  }

  const handleArrivingAirlineChange = (newValue) => {
    setArrivingFlightAirline(newValue ? newValue.toUpperCase() : "");
  }

  const handleDepartingAirlineChange = (newValue) => {
    setDepartingFlightAirline(newValue ? newValue.toUpperCase() : "");
  }

  const handleStateChange = (newValue) => {
    setState(newValue ? newValue.toUpperCase() : "");
  }

  const handleClosestAsthaanChange = (newValue) => {
    {/* TODO: front end and backend name mismatch */ }
    setClosestAsthan(newValue ? newValue.toUpperCase() : "");
  }

  const handleArrivingFlightAirportChange = (newValue) => {
    setArrivingFlightAirport(newValue);
  }

  const setSangatDepartingFlightNumber = (e) => {
    setDepartingFlightNumber(e.target.value ? e.target.value.toUpperCase() : "");
  }

  const setSangatPhoneNumber = (e) => {
    setPhone(e.target.value ? e.target.value.toUpperCase() : "");
  }

  const setSangatEmail = (e) => {
    setEmail(e.target.value ? e.target.value.toUpperCase() : "");
  }

  const setSangatSecondaryPhone = (e) => {
    setSecondaryPhone(e.target.value ? e.target.value.toUpperCase() : "");
  }

  const setSangatComments = (e) => {
    setComments(e.target.value ? e.target.value.toUpperCase() : "")
  }

  const setUserRideFromAirport = (e) => {
    setIsNeedRide(e.target.value ? e.target.value.toUpperCase() : "")
    e.target.value === "YES" ? setShowFlightInformation(true) : setShowFlightInformation(false);
  }


  return (
    <>
      {showConfirmationModal ? <ConfirmationModal user={sangat} handleClose={handleClose} /> :
        <Dialog fullScreen={fullScreen} maxWidth={"md"} open={true} onClose={handleClose} >

          <DialogTitle style={{ "borderBottom": "1px solid lightgrey" }}>{title}
            {!hideCloseBtn && <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            }
          </DialogTitle>
          <DialogContent style={{ backgroundColor: "#f2f2f2" }} sx={{ backgroundColor: '#f2f2ff2' }}>
            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loading}
            >
              <CircularProgress />
            </Backdrop>

            <Box id="startForm" sx={{
              background: '#FFFFFF',
              borderRadius: '6px',
              padding: '1rem',
              margin: '1rem',
            }}>

              <Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open={snack.open} autoHideDuration={snack.duration} onClose={closeSnack}>
                <Alert onClose={closeSnack} variant="filled" severity={snack.severity} sx={{ width: '100%' }}>
                  {snack.message}
                </Alert>
              </Snackbar>

              <h4>
                Personal Information
              </h4>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextField error={!isValidRequiredField(firstName)} helperText={getRequiredFieldHelperText(firstName, "First name")} autoComplete="p" fullWidth required label="First Name" value={firstName} onChange={setSangatFirstName} variant="outlined" />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField error={!isValidRequiredField(middleName)} helperText={getRequiredFieldHelperText(middleName, "Middle name")} autoComplete="p" fullWidth required label="Middle Name" value={middleName} onChange={setSangatMiddleName} variant="outlined" />

                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField error={!isValidRequiredField(lastName)} helperText={getRequiredFieldHelperText(lastName, "Last name")} autoComplete="p" fullWidth required label="Last Name" value={lastName} onChange={setSangatLastName} variant="outlined" />

                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth error={!isValidRequiredField(gender)}>
                    <InputLabel id="genderLabel">Gender *</InputLabel>
                    <Select
                      // needed to remove warning messages about unmounted component on console
                      defaultValue={""}
                      required
                      labelId="genderLabel"
                      id="genderSelect"
                      value={gender}
                      label="Gender"
                      onChange={setSangatGender}
                    >
                      <MenuItem value={"FEMALE"}>FEMALE</MenuItem>
                      <MenuItem value={"MALE"}>MALE</MenuItem>

                    </Select>
                    {!gender && showValidationMessages &&
                      <FormHelperText>{getRequiredFieldHelperText(gender, "Gender")}</FormHelperText>
                    }
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label={getDateFieldLabel("Birthdate")}
                      inputFormat={LOCAL_DATE_FORMAT}
                      disableFuture={true}
                      value={dob}
                      onChange={setSangatDob}
                      renderInput={(params) => <TextField required sx={{ width: "100%" }} {...params} error={!isValidDob(dob, true)} helperText={getDobHelperText(dob, true, "Birthdate")} />}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <Autocomplete
                      options={asthaans.sort()}
                      value={closestAsthan}
                      onChange={(e, newValue) => {
                        setClosestAsthan(newValue ? newValue.toUpperCase() : "");
                      }}

                      renderInput={(params) => <TextField error={!isValidRequiredField(closestAsthan)} required autoComplete="p" label="Your Local Asthaan" sx={{ width: '100%' }} helperText={getRequiredFieldHelperText(closestAsthan, "Closest Asthaan")} {...params} />} />

                  </FormControl>
                </Grid>
                <AutoCompleteWithOther error={!isValidRequiredField(country)} helperText={getRequiredFieldHelperText(country, "Country")} optionsList={countries.sort()} label={"Country"} value={country} handleChangeCallBack={handleCountryChange} />

                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    {stateOptions && stateOptions.length > 0 &&
                      <Autocomplete
                        options={stateOptions}
                        value={state}
                        onChange={(e, newValue) => {
                          handleStateChange(newValue);
                        }}
                        renderInput={(params) => <TextField error={!isValidRequiredField(state)} helperText={getRequiredFieldHelperText(state, "State/Province")} autoComplete="p" label="State/Province" sx={{ width: '100%' }} {...params} />} />
                    }
                    {(!stateOptions || stateOptions.length == 0) &&
                      <TextField error={!isValidRequiredField(state)} helperText={getRequiredFieldHelperText(state, "State/Province")} fullWidth required label="State/Province" value={state} onChange={(e) => { handleStateChange(e.target.value) }} variant="outlined" />

                    }
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField error={!isValidRequiredField(city)} helperText={getRequiredFieldHelperText(city, "City")} autoComplete="p" fullWidth required label="City" value={city} onChange={setSangatCity} variant="outlined" />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField error={!isValidPhoneNumber(phone, true)} helperText={getPhoneHelperText(phone, true, "Phone")} autoComplete="p" fullWidth required label="Phone" value={phone} onChange={setSangatPhoneNumber} variant="outlined" />
                </Grid>

                <Grid item xs={12} md={4}>

                  <TextField error={!isValidPhoneNumber(secondaryPhone, false)} helperText={getPhoneHelperText(secondaryPhone, false, "Secondary phone")} autoComplete="p" fullWidth label="Secondary Phone" value={secondaryPhone} onChange={setSangatSecondaryPhone} variant="outlined" />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField error={!isValidEmail(email, false)} helperText={getEmailHelperText(email, false, "Email")} autoComplete="p" fullWidth label="Email" type="email" value={email} onChange={setSangatEmail} variant="outlined" />
                </Grid>

                <Grid item xs={12} md={12}>
                  <TextField
                    fullWidth
                    label="Comments"
                    multiline
                    rows={3}
                    value={comments}
                    onChange={setSangatComments}

                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth error={!isValidRequiredField(needRide)} >
                    <InputLabel id="needArrivalRideLabel">Need Ride From Airport*</InputLabel>
                    <Select
                      // needed to remove warning messages about unmounted component on console
                      defaultValue={""}
                      required
                      labelId="needArrivalRideLabel"
                      id="arrivalRideSelect"
                      value={needRide}
                      label="Need Ride From Airport"
                      onChange={setUserRideFromAirport}
                    >
                      <MenuItem value={"NO"}>NO</MenuItem>
                      <MenuItem value={"YES"}>YES</MenuItem>

                    </Select>
                    <FormHelperText>{getRequiredFieldHelperText(needRide, "Need ride from airport")}</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>

            </Box>
            {showFlightInfomation ?
              <>
                <Box sx={{
                  background: '#FFFFFF',
                  borderRadius: '6px',
                  padding: '1rem',
                  margin: '1rem',
                }}>
                  <h4>
                    Arriving Flight
                  </h4>

                  <Grid container spacing={2}>
                    <AutoCompleteWithOther error={!isValidRequiredField(arrivingFlightAirline)} helperText={getRequiredFieldHelperText(arrivingFlightAirline, "Arrival airline")} optionsList={AirlineNames.sort()} label={"Arrival Airline"} value={arrivingFlightAirline} handleChangeCallBack={handleArrivingAirlineChange} />

                    <Grid item xs={12} md={4}>
                      <TextField error={!isValidRequiredField(arrivingFlightNumber)} helperText={getRequiredFieldHelperText(arrivingFlightNumber, "Flight number")} autoComplete="p" fullWidth required label="Flight Number" value={arrivingFlightNumber} onChange={(e) => { setArrivingFlightNumber(e.target.value ? e.target.value.toUpperCase() : "") }} variant="outlined" />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} >

                        <DatePicker
                          inputFormat={LOCAL_DATE_FORMAT}
                          label={getDateFieldLabel("Arrival Date")}
                          value={arrivingFlightDate}
                          disablePast={!overrideValidation}
                          onChange={(newValue) => {
                            setArrivingFlightDate(newValue);
                          }}
                          renderInput={(params) => <TextField required sx={{ width: '100%' }} {...params} error={!isValidArrivalDate()} helperText={getArrivalDateHelperText()} />}
                        />
                      </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} >

                        <TimePicker
                          label="Arrival Time"
                          ampm={false}
                          ampmInClock={false}
                          value={arrivingFlightTime}
                          onChange={(newValue) => {
                            setSangatArrivalTime(newValue);
                          }}
                          renderInput={(params) => <TextField required sx={{ width: '100%' }} {...params} error={!isValidTime(arrivingFlightTime, true)} helperText={getTimeHelperText(arrivingFlightTime, true, "Arrival time")} />}
                        />
                      </LocalizationProvider>
                    </Grid>

                    <AutoCompleteWithOther error={!isValidRequiredField(arrivingFlightAirport)} helperText={getRequiredFieldHelperText(arrivingFlightAirport, "Arrival airport")} optionsList={INDIA_AIRPORT_LIST.sort()} label={"Arrival Airport"} value={arrivingFlightAirport} handleChangeCallBack={handleArrivingFlightAirportChange} />
                  </Grid>

                </Box>
                <Box sx={{
                  background: '#FFFFFF',
                  borderRadius: '6px',
                  padding: '1rem',
                  margin: '1rem',
                }}>
                  <h4>
                    Return Flight
                  </h4>
                  <Grid container spacing={2}>
                    <AutoCompleteWithOther error={!isValidRequiredField(departingFlightAirline)} helperText={getRequiredFieldHelperText(departingFlightAirline, "Return airline")} optionsList={AirlineNames.sort()} label={"Return Airline"} value={departingFlightAirline} handleChangeCallBack={handleDepartingAirlineChange} />
                    <Grid item xs={12} md={4}>
                      <TextField error={!isValidRequiredField(departingFlightNumber)} helperText={getRequiredFieldHelperText(departingFlightNumber, "Return flight number")} autoComplete="p" fullWidth required label="Return Flight Number" value={departingFlightNumber} onChange={setSangatDepartingFlightNumber} variant="outlined" />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} >
                        <DatePicker
                          inputFormat={LOCAL_DATE_FORMAT}
                          label={getDateFieldLabel("Return Date")}
                          value={departingFlightDate}
                          disablePast={!overrideValidation}
                          onChange={(newValue) => {
                            setDepartingFlightDate(newValue)
                          }}
                          renderInput={(params) => <TextField required sx={{ width: '100%' }} {...params} error={!isValidDepartureDate()} helperText={getDepartureDateHelperText()} />}
                        />
                      </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} >

                        <TimePicker
                          label="Return Time"
                          inputFormat={"HH:mm"}
                          ampm={false}
                          ampmInClock={false}
                          value={departingFlightTime}
                          onChange={(newValue) => {
                            setSangatDepartureTime(newValue);
                          }}
                          renderInput={(params) => <TextField required sx={{ width: '100%' }} {...params} error={!isValidTime(departingFlightTime, true)} helperText={getTimeHelperText(departingFlightTime, true, "Return time")} />}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <AutoCompleteWithOther error={!isValidRequiredField(departingFlightAirport)} helperText={getRequiredFieldHelperText(departingFlightAirport, "Return airport")} optionsList={INDIA_AIRPORT_LIST.sort()} label={"Return Airport"} value={departingFlightAirport} handleChangeCallBack={setDepartingFlightAirport} />
                  </Grid>
                </Box>
              </>
              :
              <Box sx={{
                background: '#FFFFFF',
                borderRadius: '6px',
                padding: '1rem',
                margin: '1rem',
              }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} >

                      <DatePicker
                        inputFormat={LOCAL_DATE_FORMAT}
                        label={getDateFieldLabel("Estimated Arrival Date")}
                        value={arrivingFlightDate}
                        disablePast={!overrideValidation}
                        onChange={(newValue) => {
                          setArrivingFlightDate(newValue);
                        }}
                        renderInput={(params) => <TextField required sx={{ width: '100%' }} {...params} error={!isValidArrivalDate()} helperText={getArrivalDateHelperText()} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                      <DatePicker
                        inputFormat={LOCAL_DATE_FORMAT}
                        label={getDateFieldLabel("Estimated Return Date")}
                        value={departingFlightDate}
                        disablePast={!overrideValidation}
                        onChange={(newValue) => {
                          setDepartingFlightDate(newValue)
                        }}
                        renderInput={(params) => <TextField required sx={{ width: '100%' }} {...params} error={!isValidDepartureDate()} helperText={getDepartureDateHelperText()} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Box>

            }

           { currentUser && isRoomAdmin && <>
            <Box id="startForm" sx={{
              background: '#FFFFFF',
              borderRadius: '6px',
              padding: '1rem',
              margin: '1rem',
            }}>
            <h4>
                Accomodation
            </h4>
            <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <Autocomplete
                    
                      options={SARAVAN}
                     
                      value={saravan}
                      isOptionEqualToValue={(option, value) => option.label === value}       
                      
               
                      onChange={(e, newValue) => {
                        if (newValue) {
                        setSaravan(newValue.label);
                        setRoom("");
                        }
                      }}

                      renderInput={(params) => <TextField  autoComplete="p" label="Saravan" sx={{ width: '100%' }}  {...params} />} />

                  </FormControl>
                </Grid>

                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <Autocomplete
                      options={saravan ? SARAVAN.find((obj) => obj.label === saravan)?.rooms : []}
                      value={room}
              
                      disabled={saravan ? false : true}
                      onChange={(e, newValue) => {
                        setRoom(newValue ? newValue.toUpperCase() : "");
                      }}

                      renderInput={(params) => <TextField  autoComplete="p" label="Room" sx={{ width: '100%' }}  {...params} />} />

                  </FormControl>
                </Grid>

            </Grid>
            </Box>
           </>
            
          }
          </DialogContent>
          <DialogActions style={{ "borderTop": "1px solid lightgrey" }}>
            {/* TODO: if form updated open dialog that tells user all changes made will be lost, are you sure you want to close */}
            {/* <Button variant="outlined" size="large" onClick={handleClose}>{sangatValue._id ? "Close" : "Cancel"}</Button> */}
            <Button variant="contained" size="large" onClick={addNewSangat}>{saveBtnText ? saveBtnText : "Save & Close"}</Button>
            {onSaveAndAddNewCallBack && <Button variant="contained" size="large" onClick={saveAndAddNewSangat}>Save & Add Traveller</Button>}

            {overrideValidation &&
              <Button color='error' size="large" variant="outlined" onClick={() => deleteUser()}>Delete</Button>

            }
          </DialogActions>
        </Dialog>
      }
    </>
  );

};


export default AddEditUserForm;